import { FormFilter, type FormFilterSettings } from '../models';

export type EmptyFilterSettings = FormFilterSettings;

export class EmptyFilter extends FormFilter<EmptyFilterSettings> {
  public override onFilter(value: any): any {
    return value;
  }
}
